import { zetApi } from '@zet/network'

import ENDPOINTS from '../endpoints'

interface Response {
  status: number
  statusCode: number
  data: {
    partnerId: number
    customerId: number
    onecode: string
    metadata?: {
      partnerPrimaryColor: string
      applicationType: string
    }
    v2: boolean
    leadSource?: string
  }
}

export async function applicationDetails(hash: string, isLOS: boolean) {
  const response = await zetApi.request<Response>({
    url: ENDPOINTS.applicationDetails.endpoint(isLOS),
    method: ENDPOINTS.applicationDetails.method,
    headers: {
      hash: encodeURIComponent(hash),
    },
  })

  return response?.data?.data
}
